var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "conversation-container" },
    [
      _c("div", { staticClass: "conversation-container-header" }, [
        _vm._m(0),
        _vm.orgInfo && _vm.orgInfo.organizationId !== 100000
          ? _c(
              "div",
              { staticClass: "conversation-container-footer relative" },
              [
                _c(
                  "div",
                  {
                    staticClass: "conversation-container-footer-box",
                    class: { active: _vm.isAICenter },
                    on: { click: _vm.onhandleClickAICenter },
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: require("@/assets/image/aigc/aiCenter.png"),
                      },
                    }),
                    _c("div", [_vm._v("助手中心")]),
                  ]
                ),
                _c("div", { staticClass: "line-bottom" }),
              ]
            )
          : _vm._e(),
        _c("div", { staticClass: "searchBoxView" }, [
          _c("div", { staticClass: "searchBox" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.searchText && _vm.inputTextBol,
                    expression: "!searchText && inputTextBol",
                  },
                ],
                staticClass: "searchText",
              },
              [
                _c("img", {
                  attrs: {
                    src: require("@/assets/image/aigc/sousuo_icon.png"),
                    alt: "",
                  },
                }),
                _c("span", [_vm._v("搜索")]),
              ]
            ),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.searchText,
                  expression: "searchText",
                },
              ],
              staticStyle: { border: "none" },
              attrs: { disabled: !_vm.getIsAIEnd(), type: "text" },
              domProps: { value: _vm.searchText },
              on: {
                input: [
                  function ($event) {
                    if ($event.target.composing) return
                    _vm.searchText = $event.target.value
                  },
                  _vm.handleChange,
                ],
                blur: function ($event) {
                  _vm.inputTextBol = true
                },
                focus: function ($event) {
                  _vm.inputTextBol = false
                },
              },
            }),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "conversation-container-content" },
        [
          _c(
            "el-scrollbar",
            {
              ref: "scrollContainer",
              staticClass: "conversation-container-content-scroll",
              attrs: { vertical: false },
            },
            [
              _vm._l(_vm.newgetTypeAIList, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    class: {
                      "content-item": true,
                      "content-top": item.type === "AI",
                      "content-item-topSort": item.isTopping,
                      "content-item-select": item.checked && !_vm.isAICenter,
                    },
                    attrs: { id: item.id },
                    on: {
                      click: function ($event) {
                        return _vm.change(index)
                      },
                    },
                  },
                  [
                    item.isDeleted === 1
                      ? _c("div", { staticClass: "content-item-isDeleted" })
                      : _vm._e(),
                    item.type === "AI"
                      ? _c("img", {
                          attrs: {
                            src: require("@/assets/image/aigc/my_icon.png"),
                            alt: "",
                          },
                        })
                      : [
                          !!item.icon
                            ? _c("img", { attrs: { src: item.icon, alt: "" } })
                            : _c(
                                "div",
                                {
                                  staticClass: "title-span",
                                  style: { background: item.backgroundColor },
                                },
                                [
                                  _c(
                                    "span",
                                    { style: { color: item.textColor } },
                                    [_vm._v(_vm._s(item.title.split("")[0]))]
                                  ),
                                ]
                              ),
                        ],
                    _c("div", { staticStyle: { width: "154px" } }, [
                      _c(
                        "div",
                        { staticClass: "title" },
                        [
                          _c("textShowMore", {
                            attrs: { "line-clamp": 1, text: item.name },
                          }),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "describe text_hidden_1" }, [
                        _vm._v(" " + _vm._s(item.describe) + " "),
                      ]),
                    ]),
                    _c(
                      "div",
                      {
                        staticClass: "btnText",
                        attrs: { id: "btnTextWarp" },
                        on: {
                          mouseover: function ($event) {
                            return _vm.handlehover(item)
                          },
                          mouseleave: _vm.mouseleave,
                        },
                      },
                      [
                        index !== 0 && !_vm.searchText
                          ? _c("div", { staticClass: "actionBtns" }, [
                              _c("img", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.showactive.active === item.id ||
                                      _vm.active === item.id,
                                    expression:
                                      "showactive.active === item.id || active === item.id",
                                  },
                                ],
                                attrs: {
                                  id: "imgaction",
                                  src: require("@/assets/image/aigc/action.png"),
                                  alt: "",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleAction(item, $event)
                                  },
                                },
                              }),
                            ])
                          : _vm._e(),
                      ]
                    ),
                    _vm.showactive.active === item.id
                      ? _c(
                          "div",
                          {
                            staticClass: "actionBtnsTextWarp",
                            class: _vm.btnTextWarpName,
                          },
                          [
                            !item.isTopping
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "actionBtnsText",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.handleTop(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/image/aigc/top.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c("span", [_vm._v("置顶")]),
                                  ]
                                )
                              : _vm._e(),
                            !!item.isTopping
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "actionBtnsText",
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.cancelTop(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("@/assets/image/aigc/notop.png"),
                                        alt: "",
                                      },
                                    }),
                                    _c("span", [_vm._v("取消置顶")]),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass: "actionBtnsText",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.handleDel(item)
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/image/aigc/delAi.png"),
                                    alt: "",
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#f53f3f" } },
                                  [_vm._v("移除助手")]
                                ),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              _vm.newgetTypeAIList.length < 1
                ? _c(
                    "div",
                    { staticClass: "examineNull" },
                    [
                      _c("el-empty", {
                        attrs: { "image-size": 100, description: "暂无数据" },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
      _vm.isShowVideoGuide
        ? _c("videoGuide", {
            on: {
              ok: function ($event) {
                return _vm.nextGuide(2)
              },
            },
          })
        : _vm._e(),
      _vm.isShowModelChangeGuide
        ? _c("modelChangeGuide", {
            on: {
              ok: function ($event) {
                return _vm.nextGuide(1)
              },
            },
          })
        : _vm._e(),
      _vm.isShowImageGenerateGuide
        ? _c("imageGenerateGuide", {
            on: {
              ok: function ($event) {
                return _vm.nextGuide(3)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "boxTitle" }, [
      _c("img", {
        attrs: { src: require("@/assets/image/aigc/new_icon.png"), alt: "" },
      }),
      _c("span", [_vm._v("我的AI管家")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }